import request from "@/utils/request";


export function upload(formData){
  let options = {
    url:"/file/upload",
    method:"POST",
    headers:{
      'Accept': '*/*',
    },
    data: formData
  };
  return request(options);
}